export default {
  SET_SPIN_TO_WIN: 'SET_SPIN_TO_WIN',
  RESET_SPIN_TO_WIN: 'RESET_SPIN_TO_WIN',
  TICK_TIMER: 'TICK_TIMER',
  SET_SPIN_RESULT: 'SET_SPIN_RESULT',
  START_SPIN_TO_WIN: 'START_SPIN_TO_WIN',
  NEXT_STEP: 'NEXT_STEP',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  SET_CHALLENGE_END: 'SET_CHALLENGE_END',
  PAUSE_TIMER: 'PAUSE_TIMER',
};
